import TableSort from '@root/core/components/Table/Sort';
import Excel from '@root/utils/helpers/excel';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, Col, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import busksellerdetail from '../services/busksellerdetail';

interface Props {}

const OrderList = ({}: Props) => {
  const { id } = useParams<{ id: string }>();

  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState(false);
  const [selectedIds, setSelectedIds] = useState<React.Key[]>([]);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState();
  const [totalRows, setTotalRows] = useState(0);

  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no'
    },
    {
      title: '주문번호',
      dataIndex: 'orderNumber',
      key: 'orderNumber'
    },
    {
      title: '주문자명',
      dataIndex: 'buyerName',
      key: 'buyerName'
    },
    {
      title: '상품명',
      dataIndex: 'productName',
      key: 'productName'
    },
    {
      title: '물류센터명',
      dataIndex: 'warehouseName',
      key: 'warehouseName'
    },
    {
      title: '상태',
      dataIndex: 'orderStatus',
      key: 'orderStatus'
    },
    {
      title: <TableSort title="업데이트일" sort={sort} setSort={setSort} />,
      dataIndex: 'updatedAt',
      key: 'updatedAt'
    }
  ];

  const getOrders = async () => {
    setLoading(true);
    const result = await busksellerdetail.getOrderList(id, {
      page,
      limit: 10,
      sortBy: sort ? 'updated_at:ASC' : 'updated_at:DESC',
    });
    const data = result.data?.map((r: any, index: number) => {
      return {
        ...r,
        key: r.id,
        no: r.id,
        updatedAt: formatDateTime(r.updatedAt),
      };
    });

    setRows(data);
    setTotalRows(result?.meta?.totalItems ?? 0);
    setLoading(false);
  };

  useEffect(() => {
    getOrders();
  }, []);

  useEffect(() => {
    getOrders();
  }, [page, sort]);

  const handelExportExcel = async () => {
    const excelOption = {
      blod: undefined,
      fileName: 'Seller_Order.xlsx'
    };

    excelOption.blod = await busksellerdetail.exportSellerExcellOrder(id, {
      sortBy: sort ? 'updated_at:ASC' : 'updated_at:DESC',
      listId: selectedIds.map((item) => Number(item))
    });

    Excel.download(excelOption);
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedIds(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedIds,
    onChange: onSelectChange
  };

  return (
    <>
      <div className="busk-sellerSubHead">
        <Row align="middle">
          <Col flex="auto">
            <Row gutter={15}>
              <Col>
                <Typography.Text>총 배송 {totalRows}</Typography.Text>
              </Col>
              <Col>|</Col>
              <Col>
                <Typography.Text>
                  선택 배송 {selectedIds.length}
                </Typography.Text>
              </Col>
            </Row>
          </Col>
          <Col>
            <Button
              style={{
                color: 'gray'
              }}
              onClick={handelExportExcel}
            >
              엑셀 다운로드
            </Button>
          </Col>
        </Row>
      </div>

      <Table
        className="busk-table"
        rowSelection={rowSelection}
        pagination={{
          pageSize: 10,
          total: totalRows,
          onChange: (newPage) => {
            setPage(newPage);
          }
        }}
        loading={loading}
        columns={columns}
        dataSource={rows}
      />
    </>
  );
};

export default OrderList;
